export const UPDATE_USER_DETAILS = "UPDATE_USER_DETAILS";
export const CLEAR_USER_DETAILS = "CLEAR_USER_DETAILS";
export const SET_USER_LOGIN = "SET_USER_LOGIN";
export const SET_FORGET_PASSWORD_EMAIL = "SET_FORGET_PASSWORD_EMAIL";
export const SET_VERIFICATION_LINK = "SET_VERIFICATION_LINK";
export const SET_SELECTED_TAB = "SET_SELECTED_TAB";
export const MENU_BAR_TOGGLE_STATE = "MENU_BAR_TOGGLE_STATE";

